import React__default from 'react';

const SearchIcon = () => {
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
        React__default.createElement("path", { d: 'M10.2515 10.2515C9.34499 11.1579 8.11554 11.6672 6.83359 11.6672C5.55165 11.6672 4.3222 11.1579 3.41573 10.2515C2.50925 9.34499 2 8.11554 2 6.83359C2 5.55165 2.50925 4.3222 3.41573 3.41573C4.3222 2.50925 5.55165 2 6.83359 2C8.11554 2 9.34499 2.50925 10.2515 3.41573C11.1579 4.3222 11.6672 5.55165 11.6672 6.83359C11.6672 8.11554 11.1579 9.34499 10.2515 10.2515ZM10.2515 10.2515L14 14.0005', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

export { SearchIcon };
//# sourceMappingURL=SearchIcon.js.map
